export interface ITabOption {
    label: string;
    name: string;
    value: string;
}

export interface IQuickBooksNotifyConnectionModal {
    showModal: boolean;
}

export enum TabOption {
    Yes = 'yes',
    No = 'no',
}

export interface IQuickBookVerificationModalProps {
    showModal: boolean;
    closeModalHandler: () => void;
    closeModal: () => void;
}

export interface IErrorInput {
    userName: boolean;
}

export interface IQuickBookInitialState {
    isQuickBookAuthenticated: boolean;
    selectedTabOption: TabOption;
    isLoading: boolean;
    userEmail: string;
    inputErrors: IErrorInput;
    userQbRequestID: number;
    qbSettingId: number;
}
